import React from "react";
import PropTypes from "prop-types";
import useStyles from "@hooks/useStyles";
import useConstants from "@hooks/useConstants";
import useStores from "@hooks/useStores";

import Box from "@material-ui/core/Box";
import Slide from "@material-ui/core/Slide";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";

const { SITE_NAME } = process.env;

const ContentSlideCTA = () => {
	const classes = useStyles("Content");
	const { contentStore: store } = useStores();
	const { slideCTATitle, slideCTAButton } = useConstants("ContentViewModel");

	const trigger = useScrollTrigger({
		threshold: 600,
		disableHysteresis: true,
	});

	return (
		<>
			<div>
				<Slide direction={"down"} in={trigger}>
					<Box
						position={"fixed"}
						height={{ xs: 64, sm: 73 }}
						left={0}
						right={0}
						top={0}
						width={"100%"}
						bgcolor={"#FFF"}
						zIndex={1111111111}
						borderTop={1}
						borderColor="grey.200"
						display={"flex"}
						alignItems="center"
						className={classes.slideCTA}
					>
						<Container maxWidth="md">
							<Box
								display={"flex"}
								alignItems={"center"}
								justifyContent={"center"}
								alignContent={"center"}
								flexDirection={"row"}
								flexWrap={"nowrap"}
								px={2}
							>
								<Box
									display={{ xs: "none", sm: "block" }}
									mr={5}
									fontWeight={700}
									fontSize={18}
									style={{ userSelect: "none" }}
								>
									{slideCTATitle}
								</Box>
								<Box flex={{ xs: 1, sm: "0 0 200px" }}>
									<Button
										fullWidth
										href={
											SITE_NAME === "trustedcare"
												? "/"
												: `${store.service?.url}?utm_source=content&utm_medium=slide&utm_content=content&utm_campaign=slide`
										}
										target="_blank"
										variant="contained"
										color="primary"
										disableElevation
									>
										{slideCTAButton}
									</Button>
								</Box>
							</Box>
						</Container>
					</Box>
				</Slide>
			</div>
		</>
	);
};

ContentSlideCTA.propTypes = {};
export default ContentSlideCTA;
